var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02IconoComunicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.452,
    y1: -0.107,
    x2: -3.45,
    y2: -0.103,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "etapas",
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)",
    fill: "none",
    stroke: "#f0f4f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: "1 12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 21.721,
    cy: 21.721,
    r: 21.721,
    fill: "#fdfffc",
    stroke: "#f0f4f9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)",
    fill: "#7821a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(-245.425 -95.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(297.553 115.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(1.222 6.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    "data-name": "Trazado 394",
    d: "M372.028,157.146v37.88H318.263v-37.88a2.451,2.451,0,0,1,2.444-2.444h48.877A2.451,2.451,0,0,1,372.028,157.146Z",
    transform: "translate(-309.709 -142.482)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M368.362,157.146v37.88h-50.1v-37.88a2.451,2.451,0,0,1,2.444-2.444h45.212A2.451,2.451,0,0,1,368.362,157.146Z",
    transform: "translate(-309.709 -142.482)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    "data-name": "Trazado 396",
    d: "M371.014,245.948v2.444H300.142v-2.444l8.554-11h53.765Z",
    transform: "translate(-300.142 -184.85)",
    fill: "#7fabfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    "data-name": "Trazado 397",
    d: "M367.348,245.948v2.444H300.142v-2.444l8.554-11h50.1Z",
    transform: "translate(-300.142 -184.85)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    "data-name": "Trazado 398",
    d: "M371.014,258.248v2.444a2.451,2.451,0,0,1-2.444,2.444H302.586a2.451,2.451,0,0,1-2.444-2.444v-2.444Z",
    transform: "translate(-300.142 -197.151)",
    fill: "#7fabfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    "data-name": "Trazado 399",
    d: "M367.348,258.248v2.444a2.451,2.451,0,0,1-2.444,2.444H302.586a2.451,2.451,0,0,1-2.444-2.444v-2.444Z",
    transform: "translate(-300.142 -197.151)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M372.9,173.684v5.23h-39.1V173.5a7.367,7.367,0,0,1,3.715-6.452l7.93-4.46a3.361,3.361,0,0,0,1.686-2.933v-2.114a.9.9,0,0,0-.183-.55,20.5,20.5,0,0,1-3.373-7.1v-12.83s-.941-7.283,7.943-8.163a17.464,17.464,0,0,1,1.833-.085c10.838,0,9.775,8.248,9.775,8.248v12.83a20.5,20.5,0,0,1-3.372,7.1.9.9,0,0,0-.184.55v2.2a3.355,3.355,0,0,0,1.784,2.994l7.612,4.362A7.419,7.419,0,0,1,372.9,173.684Z",
    transform: "translate(-317.909 -128.814)",
    fill: "#efd2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    "data-name": "Trazado 401",
    d: "M369.23,173.78v5.23H333.794V173.6a7.367,7.367,0,0,1,3.715-6.452l7.93-4.46a3.361,3.361,0,0,0,1.686-2.933v-2.114a.9.9,0,0,0-.183-.55,20.5,20.5,0,0,1-3.373-7.1v-12.83s-.941-7.283,7.943-8.163c8.883.88,7.942,8.163,7.942,8.163v12.83a20.5,20.5,0,0,1-3.372,7.1.9.9,0,0,0-.184.55v2.2a3.356,3.356,0,0,0,1.784,2.994l7.613,4.362A7.419,7.419,0,0,1,369.23,173.78Z",
    transform: "translate(-317.909 -128.91)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    "data-name": "Trazado 402",
    d: "M369.28,175.411h2.444a1.833,1.833,0,0,1,1.833,1.833v1.222a1.833,1.833,0,0,1-1.833,1.833H369.28a1.833,1.833,0,0,1-1.833-1.833v-1.222A1.833,1.833,0,0,1,369.28,175.411Z",
    transform: "translate(-335.677 -153.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55",
    transform: "translate(20.773 9.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 4.888,
    height: 8.554,
    transform: "translate(0 0)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_403",
    "data-name": "Trazado 403",
    d: "M399.589,158.078h-3.666v-8.554h4.887v7.332A1.222,1.222,0,0,1,399.589,158.078Z",
    transform: "translate(-371.484 -149.524)",
    fill: "#efd2ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_404",
    "data-name": "Trazado 404",
    d: "M303.808,206.023v-2.444l8.553-11V157.146a2.451,2.451,0,0,1,2.444-2.444h-3.666a2.451,2.451,0,0,0-2.444,2.444v35.436l-8.553,11v2.444a2.451,2.451,0,0,0,2.444,2.444h3.666A2.451,2.451,0,0,1,303.808,206.023Z",
    transform: "translate(-298.92 -136.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_405",
    "data-name": "Trazado 405",
    d: "M318.118,159.879v35.436h-2.444V159.879Z",
    transform: "translate(-307.12 -139.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M370.776,182.615c-.009-.021-.023-.037-.033-.057a1.232,1.232,0,0,0-.132-.23l-8.3-10.666V136.645a3.669,3.669,0,0,0-3.666-3.666H350.1v-1.222a15.617,15.617,0,0,0-15.3-15.885h-1.174a15.617,15.617,0,0,0-15.3,15.885v1.222h-8.554a3.669,3.669,0,0,0-3.666,3.666v4.888a1.222,1.222,0,0,0,2.444,0v-4.888a1.223,1.223,0,0,1,1.222-1.222h8.554v7.943a4.172,4.172,0,0,0,4.048,4.277h2.476a24.212,24.212,0,0,0,1.918,3.159v2.019a2.119,2.119,0,0,1-1.065,1.869l-7.925,4.461a8.593,8.593,0,0,0-4.34,7.519v4.191H308.55V151.308a1.222,1.222,0,1,0-2.444,0v20.354l-8.3,10.666a1.2,1.2,0,0,0-.132.231c-.009.02-.024.035-.032.056a1.211,1.211,0,0,0-.085.418c0,.016-.009.029-.009.046v2.444a3.669,3.669,0,0,0,3.666,3.666H367.2a3.669,3.669,0,0,0,3.666-3.666v-2.444c0-.017-.008-.03-.009-.046A1.2,1.2,0,0,0,370.776,182.615ZM358.65,135.423a1.223,1.223,0,0,1,1.222,1.222v34.214h-4.887v-4.009a8.546,8.546,0,0,0-4.55-7.639l-7.661-4.4a2.12,2.12,0,0,1-1.12-1.9V150.8a21.725,21.725,0,0,0,3.525-7.475,1.176,1.176,0,0,0,.03-.266v-1.527h2.444a2.448,2.448,0,0,0,2.444-2.444v-3.666Zm-11,3.666h-2.444v-6.11h2.444v6.11Zm-14.029-20.773H334.8a13.107,13.107,0,0,1,12.795,12.22h-2.385v-.243a8.688,8.688,0,0,0-2.017-6.281c-1.9-2.158-4.92-3.252-8.981-3.252s-7.082,1.094-8.981,3.252a8.688,8.688,0,0,0-2.017,6.281v.243h-2.385A13.107,13.107,0,0,1,333.624,118.316ZM320.77,132.979h2.444v6.11H320.77Zm1.6,12.22a1.732,1.732,0,0,1-1.6-1.833v-1.833h2.444v1.527a1.2,1.2,0,0,0,.03.266,15.987,15.987,0,0,0,.556,1.873Zm-6.491,21.47a6.149,6.149,0,0,1,3.092-5.388l7.921-4.459a4.559,4.559,0,0,0,2.317-4v-2.112a2.139,2.139,0,0,0-.417-1.277,20.982,20.982,0,0,1-1.168-1.789h1.758a3.06,3.06,0,0,0,2.993,2.444h2.444a3.057,3.057,0,0,0,3.055-3.055v-1.222a3.058,3.058,0,0,0-3.055-3.055h-2.444a3.06,3.06,0,0,0-2.993,2.444H326.4a14.8,14.8,0,0,1-.745-2.277V130.23a1.3,1.3,0,0,0-.01-.155,6.294,6.294,0,0,1,1.417-4.449c1.415-1.607,3.82-2.422,7.147-2.422,3.311,0,5.709.808,7.126,2.4a6.284,6.284,0,0,1,1.437,4.47,1.319,1.319,0,0,0-.009.155v12.692a19.362,19.362,0,0,1-3.139,6.512,2.132,2.132,0,0,0-.416,1.275v2.2a4.534,4.534,0,0,0,2.391,4.048l7.662,4.4a6.217,6.217,0,0,1,3.277,5.495v4.009H315.882Zm15.885-20.859a.612.612,0,0,1,.611-.611h2.444a.612.612,0,0,1,.611.611v1.222a.612.612,0,0,1-.611.611h-2.444a.612.612,0,0,1-.611-.611ZM307.926,173.3H360.5l6.653,8.554H301.274Zm60.5,12.219a1.223,1.223,0,0,1-1.222,1.222H301.219A1.223,1.223,0,0,1,300,185.522V184.3h68.428v1.222Z",
    transform: "translate(-297.553 -115.872)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M371.53,245.3h-39.1a1.222,1.222,0,1,0,0,2.444h39.1a1.222,1.222,0,1,0,0-2.444Z",
    transform: "translate(-315.321 -184.208)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M320.707,245.3h-1.222a1.222,1.222,0,0,0,0,2.444h1.222a1.222,1.222,0,0,0,0-2.444Z",
    transform: "translate(-308.487 -184.208)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M426.842,245.3H425.62a1.222,1.222,0,1,0,0,2.444h1.222a1.222,1.222,0,1,0,0-2.444Z",
    transform: "translate(-364.523 -184.208)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    "data-name": "Trazado 410",
    d: "M316.88,180.444a1.227,1.227,0,0,0,.868-2.09l-.183-.147a.944.944,0,0,0-.22-.11.775.775,0,0,0-.22-.073,1.767,1.767,0,0,0-.244-.024,1.281,1.281,0,0,0-.868.354,1.2,1.2,0,0,0,.4,1.992A1.228,1.228,0,0,0,316.88,180.444Z",
    transform: "translate(-307.104 -148.673)",
    fill: "#264ecc"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    "data-name": "Trazado 411",
    d: "M336.091,135.423h0v7.943a4.172,4.172,0,0,0,4.048,4.277h2.476a24.209,24.209,0,0,0,1.918,3.159v2.019a2.119,2.119,0,0,1-1.065,1.869l-7.925,4.461a8.593,8.593,0,0,0-4.34,7.519v4.191h2.444v-4.191a6.149,6.149,0,0,1,3.092-5.388l7.921-4.459a4.561,4.561,0,0,0,2.318-4v-2.112a2.139,2.139,0,0,0-.418-1.277,20.982,20.982,0,0,1-1.168-1.789h1.758a3.06,3.06,0,0,0,2.993,2.444h2.444a3.058,3.058,0,0,0,3.055-3.055v-1.222a3.058,3.058,0,0,0-3.055-3.055h-2.444a3.06,3.06,0,0,0-2.993,2.444H344.17a14.793,14.793,0,0,1-.745-2.277V130.23a1.32,1.32,0,0,0-.01-.155,6.294,6.294,0,0,1,1.417-4.449c1.415-1.607,3.82-2.422,7.147-2.422,3.311,0,5.709.808,7.126,2.4a6.284,6.284,0,0,1,1.437,4.47,1.313,1.313,0,0,0-.009.155v12.692a19.361,19.361,0,0,1-3.139,6.512,2.132,2.132,0,0,0-.416,1.275v2.2a4.534,4.534,0,0,0,2.391,4.048l7.662,4.4a6.218,6.218,0,0,1,3.277,5.5v4.009h2.444v-4.009a8.545,8.545,0,0,0-4.55-7.639l-7.661-4.4a2.12,2.12,0,0,1-1.12-1.9V150.8a21.719,21.719,0,0,0,3.525-7.475,1.146,1.146,0,0,0,.03-.266v-1.527h2.444a2.444,2.444,0,0,0,2.439-2.394V131.1a15.616,15.616,0,0,0-15.293-15.233h-1.174a15.617,15.617,0,0,0-15.3,15.885v1.222h0Zm13.443,10.387a.612.612,0,0,1,.611-.611h2.444a.612.612,0,0,1,.611.611v1.222a.612.612,0,0,1-.611.611h-2.444a.612.612,0,0,1-.611-.611Zm15.885-6.721h-2.444v-6.11h2.444Zm-14.029-20.773h1.174a13.107,13.107,0,0,1,12.795,12.22h-2.385v-.243a8.688,8.688,0,0,0-2.017-6.281c-1.9-2.158-4.92-3.252-8.981-3.252s-7.082,1.094-8.981,3.252a8.688,8.688,0,0,0-2.017,6.281v.243H338.6A13.107,13.107,0,0,1,351.391,118.316Zm-12.854,14.663h2.444v6.11h-2.444Zm0,8.554h2.444v1.527a1.2,1.2,0,0,0,.03.266,16.087,16.087,0,0,0,.556,1.873H340.14a1.732,1.732,0,0,1-1.6-1.833Z",
    transform: "translate(-17.767 0)",
    fill: "#7821a0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02IconoComunicate);
export default __webpack_public_path__ + "static/media/02-icono-comunicate.7f83cfb410e80250f5c4cb975840078e.svg";
export { ForwardRef as ReactComponent };